'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIControllable;

var _underscore = require('../utils/underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropNames = require('../core/PropNames');

var _reactUtils = require('react-utils');

var _utils = require('./utils');

var _decorators = require('../utils/propTypes/decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_FIELDS = ['value'];
var DISPLAY_NAME_PREFIX = 'Controllable';

/**
 * @param  {React.Component}
 * @param  {Array<string>}
 * @return {Object}
 */
function _getDefaultProps(component, fields) {
  // shallow copy of defaultProps to use as the initial value to prevent mutation
  var defaultProps = _extends({}, component.defaultProps);

  return fields.reduce(function (defaults, field) {
    if (defaults.hasOwnProperty(field)) {
      defaults[(0, _PropNames.getDefaultPropName)(field)] = defaults[field];
      delete defaults[field];
    }
    return defaults;
  }, defaultProps);
}

/**
 * @param  {Object}
 * @param  {Array<string>}
 * @return {Object}
 */
function getDefaultPropTypes(originalPropTypes, fields) {
  return fields.reduce(function (propTypes, field) {
    var originalPropType = propTypes[field];
    if (typeof originalPropType !== 'function') {
      originalPropType = _react.PropTypes.any;
    }
    var notRequiredPropType = (0, _decorators.notRequired)(originalPropType);
    propTypes[(0, _PropNames.getDefaultPropName)(field)] = notRequiredPropType;
    propTypes[field] = notRequiredPropType;
    return propTypes;
  }, (0, _underscore.clone)(originalPropTypes) || {});
}

/**
 * @param  {Array<string>}
 * @return {Object}
 */
function getHandlerPropTypes(fields) {
  return fields.reduce(function (propTypes, field) {
    propTypes[(0, _PropNames.getOnChangeName)(field)] = _react.PropTypes.func;
    return propTypes;
  }, {});
}

/**
 * @param  {React.Component}
 * @return {string}
 */
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * @param  {React.Component} component
 * @param  {string} field
 * @param  {Object} event
 * @return {void}
 */
function handleChange(component, field, evt) {
  (0, _reactUtils.invariant)(evt && evt.target != null, getDisplayName(component.constructor) + ' handleChange: expected ' + 'argument in shape of SyntheticEvent ({target: value})');

  component.setState(_defineProperty({}, field, evt.target.value));
  var onChange = component.props[(0, _PropNames.getOnChangeName)(field)];
  if (typeof onChange === 'function') {
    onChange(evt);
  }
}

/**
 * @param  {React.Component}
 * @param  {Array<string>}
 * @return {React.Component}
 */
function UIControllable(InputComponent) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FIELDS;

  var onChangeKeys = (0, _underscore.map)(fields, _PropNames.getOnChangeName);
  var defaultProps = (0, _underscore.map)(fields, _PropNames.getDefaultPropName);

  var controlledComponent = _react2.default.createClass({
    displayName: DISPLAY_NAME_PREFIX + '(' + getDisplayName(InputComponent) + ')',

    propTypes: _extends({}, getDefaultPropTypes(InputComponent.propTypes, fields), getHandlerPropTypes(fields)),

    /**
     * @return {Object}
     */
    getDefaultProps: function getDefaultProps() {
      return _getDefaultProps(InputComponent, fields);
    },


    /**
     * @return {Object}
     */
    getInitialState: function getInitialState() {
      var defaults = (0, _underscore.pick)(this.props, defaultProps);
      var initialState = {};
      Object.keys(defaults).forEach(function (defaultKey) {
        initialState[(0, _PropNames.getPropFromDefaultName)(defaultKey)] = defaults[defaultKey];
      });

      return initialState;
    },


    /**
     * @return {void}
     */
    componentWillMount: function componentWillMount() {
      var _this = this;

      var handlers = {};
      onChangeKeys.forEach(function (onChangeKey, i) {
        handlers[onChangeKey] = (0, _underscore.partial)(handleChange, _this, fields[i]);
      });
      this.handlers = handlers;
    },


    /**
     * @return {Object}
     */
    getProps: function getProps() {
      var _this2 = this;

      var applicableProps = {};
      Object.keys(this.props).forEach(function (key) {
        if (defaultProps.indexOf(key) === -1 && _this2.props[key] !== undefined) applicableProps[key] = _this2.props[key];
      });

      return _extends({}, this.state, applicableProps, this.handlers);
    },


    /**
     * @return {React.Element}
     */
    render: function render() {
      var _this3 = this;

      return _react2.default.createElement(InputComponent, _extends({}, this.getProps(), {
        ref: function ref(wrappedInstance) {
          (0, _utils.copyMethods)(wrappedInstance, _this3);
        }
      }));
    }
  });

  (0, _utils.attachWrappedComponent)(controlledComponent, InputComponent);

  return controlledComponent;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/decorators/Controllable.js
// module id = 12
// module chunks = 0